export default __webpack_public_path__ + "static/media/contacto-azul@3x.4463d583.png";